module.exports = __webpack_public_path__ + "img/notificacao.788d304e.svg";